import React from 'react';
import { PageHeader } from '../PageHeader';
import { ActivityFeed } from '../ActivityFeed';
import { RightRail } from '../RightRail';
export function FeedPage() {
  return <>
      <PageHeader title="Feed" subtitle="The latest from across the company." data-id="element-465" />
      <div className="grid grid-cols-1 xl:grid-cols-[1fr_340px] gap-6" data-id="element-466">
        <div className="min-w-0 max-w-2xl w-full" data-id="element-467">
          <ActivityFeed data-id="element-468" />
        </div>
        <div className="hidden xl:block" data-id="element-469">
          <RightRail data-id="element-470" />
        </div>
      </div>
    </>;
}